import gql from 'graphql-tag'
import { EntityFields } from '..'

export const BaseDocumentFileTypeFragment = gql`
    fragment BaseDocumentFileType on documents_field_type{
        ${EntityFields}
    }
`
